import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from '../../data-access/login.service';
import { LoginFormComponent } from '../../ui/login-form/login-form.component';
import { LoginRequest } from '../../interfaces/login.interface';
import { AuthService } from '../../../auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, take, takeUntil } from 'rxjs';
import { CommunicationType } from '../../../signup/interfaces/signUp.interface';
import { SignUpService } from '../../../signup/data-access/signup.service';

const DEFAULT_REDIRECT = 'dashboard';

@Component({
  selector: 'equine-ui-nx-login',
  standalone: true,
  imports: [CommonModule, LoginFormComponent],
  providers: [LoginService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();
  appName = '';

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private signUpService: SignUpService
  ) { 
    // this.appName = loginService.environment?.appName;
  }
  ngOnInit(): void {
      this.route.data.pipe((takeUntil(this.unsubscribe$)))
      .subscribe((data: any)=>{  
        this.appName = data.appName
    })
  }

  login(loginFormValue: LoginRequest) {
    const userInfo = {
      userName: loginFormValue.userName,
      passWord: loginFormValue.passWord,
      type: loginFormValue.type,
      appName: this.appName
    };
    
    this.loginService.login({...loginFormValue, appName: this.appName})
      .pipe(
        take(1),
        takeUntil(this.unsubscribe$))
      .subscribe({
        next: (loginResponse: any) => {
          if(loginResponse.status) {
            this.authService.isLoggedIn = true;
            this.authService.emitLoggedinUser(loginResponse.userData);
            this.authService.setSeasonSelectionConfirmation(true);
            const state = {
              accessToken: loginResponse.accessToken, 
              refreshToken: loginResponse.refreshToken, 
              userDataString: JSON.stringify(loginResponse.userData),
              redirectUrl: this.route.snapshot.data['redirectUrl'] || DEFAULT_REDIRECT
            };

            this.goToCallbackRoute(state);
          } else {
            if (loginResponse.error.message) {
              this.snackBar.open(
                loginResponse.error.message,
                'close',
                { duration: 5000, panelClass: ['error-snackbar'] }
              );
            } else {
              this.snackBar.open(
                'Internal Server Error',
                'close',
                { duration: 5000, panelClass: ['error-snackbar'] }
              );
            }
            this.resetForm();
          }
        },
        error: (err: any) => {
          if (userInfo.type == 'email' && err.error.message && err.error.message === 'User is not verified') {
            localStorage.setItem('signup-email', '' + userInfo.userName);
            this.sendVerificationCode(userInfo.userName);
          } else {
            this.snackBar.open(
              err.error.message,
              'close',
              { duration: 5000, panelClass: ['error-snackbar'] }
            );
            this.resetForm();
          }
        }
      })
  }

  goToCallbackRoute(state: any) {
    this.router.navigate(['account', 'callback'], {
      queryParams: state
    });
  }

  sendVerificationCode(email: any) {
    this.signUpService
      .generateOtp(CommunicationType.EMAIL, email, "SignUp", this.appName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data: any)=> {
          this.router.navigate(['account','not-verify']);
        },
        error: (err: any)=> {
          this.router.navigate(['account','not-verify']);
        }
      })
  }

  resetForm() {
    this.loginService.triggerFormReset();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
